module.exports = __webpack_public_path__ + "img/footer_logo_by.cc0e350d.png";